// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router, { noteTunerMayPlay } from './router';
import store from './store';
import RemoteControl from './plugin/RemoteControl';
import VueNativeSock from 'vue-native-websocket';
//import SocketPlugin from './plugin/socket'
import "core-js/stable";
// Kompatibilitaets-Anker fuer den Wechsel vom Prod-Stand 22.04.2026
// (Tag prod-2026-04-22): dessen app.js braucht dieses Modul aus vendor.js, der
// neue Code nicht mehr. Die Prod-Loader laden app.js und vendor.js ohne
// gemeinsamen Cache-Buster - ein TV mit dem alten app.js im Cache und dem
// neuen vendor.js startete sonst nicht. Entfernen, wenn alle Geraete den neuen
// Stand haben. Pruefen: scripts/check-vendor-compat.js.
import 'babel-runtime/core-js/object/entries';

//import RPIController from './helpers/RPIController';

//import i18n from './i18n';

import './assets/css/main.css';
import LangControl from './plugin/LangControl';
import DeviceType from './helpers/DeviceType';
import Cast from './helpers/Cast';
import { CAST_TOS_KEY } from './store/modules/cast';
import ForeignApp from './helpers/ForeignApp';
import { startBuildCheck } from './helpers/BuildCheck';
import WakeAlarm from './helpers/WakeAlarm';
//import socket from './store/modules/socket';
//import socketLogger from './store/modules/socket-logger';

// RPIController.init();

Vue.config.productionTip = false;
Vue.use(RemoteControl);
// Die App laeuft - Weckauftraege vom letzten Cast-Standby-Neustart sind
// erledigt oder ueberfluessig (siehe helpers/WakeAlarm). So frueh wie moeglich,
// bevor der naechste gestaffelte Auftrag die App noch einmal startet.
if (DeviceType.isTizen) WakeAlarm.clear('App-Start');

Vue.prototype.$eventBus = new Vue();
//Vue.loadScript("http://192.168.50.200:8080/static/hcap.js");

Vue.config.errorHandler = function(err, vm, info) {
  // handle error
  // `info` is a Vue-specific error info, e.g. which lifecycle hook
  // the error was found in. Only available in 2.2.0+
  console.log(err, vm, info);
  //this.$socket.sendObj({"err": err, "vm": vm, "info": info});
  //this.$logger.sendObj({"err": err, "vm": vm, "info": info});
  //socketLogger.sendObj({"err": err, "vm": vm, "info": info});
};

/*
Vue.config.warnHandler = function(msg, vm, trace) {
  // handle warn
  // `trace` is the component hierarchy trace
  console.log(err, vm, info);
  this.$socket.sendObj({"msg": msg, "vm": vm, "info": trace});
  //this.$logger.sendObj({"msg": msg, "vm": vm, "info": trace});
  socketLogger.sendObj({"msg": msg, "vm": vm, "info": trace});
};
*/

// Vue.prototype.$lang = (path) => {
//   const lang = store.getters['lang/getLang'];
//   path.split('.');
//   if (path[0] === undefined) return '';
//   let found = i18n[lang];
//   console.log(lang, found, i18n);
//   for (const step of path) {
//     if (!found) return '';
//     found = found[step];
//   }
//   return found;
// };

/*
Vue.use(VueNativeSock, 'ws://localhost:3333', {
  store: store,
  format: 'json',
  protocol: 'tv-app',
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 3000,
});
*/
//${process.env.SOCKET_BASE}
/*Vue.use(SocketPlugin, {
  //url: '${process.env.SOCKET_SERVER}', // hier deine Server-URL
  url: 'ws://localhost:3003', // hier deine Server-URL
  reconnectionAttempts: 10,
  reconnectionDelay: 3000,
});*/

Vue.use(LangControl);

// Geräte-Status an den Socket-Server melden, sobald sich Aktivität (Route),
// Sprache oder Standby ändert. reportState no-opt, solange nicht verbunden.
router.afterEach(() => store.dispatch('socket/reportState'));
store.watch(
  (s) => s.lang && s.lang.active,
  () => store.dispatch('socket/reportState')
);
// KEIN Abgleich der TV-OSD-Sprache mit der Gast-Sprache mehr (entfernt
// 30.09.2026).
//
// Gedacht war er fuer Cast, AirPlay und Spiegelung, die sich nach der
// OSD-Sprache des Geraets richten statt nach unserer App. Aber osd-language
// ist die MENUESPRACHE DES GANZEN TV: am U800F (Tizen 9) startet die Firmware
// nach jedem Wechsel die Apps neu, und nach dem dritten Wechsel kurz
// hintereinander kam statt der App der Samsung-Bildschirm "Kabel anschliessen"
// der Quelle TV - derselbe Befund wie beim ersten Anlauf ("Aerial Cable /
// Disconnected"). Die App-Sprache muss sofort und ohne Neustart wechseln.
//
// Das Setzen selbst bleibt: helpers/OsdLanguage (applyGuest, guestOsdLang) und
// set_settings osd_language aus dem SocketAdmin. Kommt es wieder, dann dort,
// wo es gebraucht wird - beim Einstieg in die Cast-Seite, nicht bei jedem
// Sprachwechsel.
// LG: Beim Aufwachen aus dem (Instant-On/Mute-)Standby immer auf Home landen.
// WebOS haelt die App im Instant-On im Speicher; beim Wake feuert kein Reload,
// sondern visibilitychange (hidden -> visible) bzw. auf manchen Firmwares das
// webOSRelaunch-Event. Ohne Reset bleibt der TV auf der zuletzt gewaehlten
// Seite haengen (z.B. TV-Player -> schwarzes Bild, kein Tuning-Restart).
function lgWakeToHome() {
  if (!DeviceType.isLG) return;
  const current = router.currentRoute && router.currentRoute.name;
  if (current !== 'Home') {
    // Nur eine Logzeile, kein zusaetzlicher Haken.
    //
    // Ein Versuch, hier mehr Ereignisse anzuhaengen (webOSLaunch,
    // webkitvisibilitychange, router.onReady), ist zurueckgenommen: der TV
    // landete weiter auf der alten Seite und sprang erst rund 60 Sekunden
    // spaeter auf Home. Ein verzoegerter Sprung von selbst ist fuer den Gast
    // schlimmer als die alte Seite - er sieht aus wie ein Geraet, das
    // eigenmaechtig handelt.
    //
    // Wer das noch einmal angeht, braucht ZUERST diese Zeile vom Geraet: sie
    // sagt, ob und WANN ueberhaupt ein Ereignis kommt. Ohne diese Antwort ist
    // jeder weitere Haken geraten.
    console.log('[LG] Aufwachen - zurueck auf Home (war auf: ' + (current || '?') + ')');
    router.replace({ name: 'Home' }).catch(() => {});
  }
}
// LG: Cast-Aufraeumen an den Standby haengen.
//
// Auf Samsung machen das der remotepower-PowerStateListener und der
// PowerStateWrapper (siehe keyHandler/Tizen.js). Auf LG gibt es beides nicht -
// hcap liefert keinen brauchbaren PowerStateListener (keyHandler/LG.js ist
// deshalb auskommentiert) und getPowerMode antwortet in der Ausschaltsequenz
// nicht mehr. Bleibt visibilitychange.
//
// Der Start einer eigenen OTT-App sieht genauso aus wie ein Standby; das
// unterscheidet der cast-Store selbst (appHandoff), deshalb wird die Quelle
// 'hidden' mitgegeben. Beim Sichtbarwerden laeuft der volle Lauf - No-op, wenn
// kein Standby vorausging (clearPending).
function lgCastPowerHook(hidden) {
  if (!DeviceType.isLG) return;
  if (hidden) {
    store.dispatch('cast/prepareForStandby', 'hidden').catch(() => {});
    return;
  }
  // Beim Sichtbarwerden ZUERST nachsehen, ob ueberhaupt ein Power-Off dazwischen
  // lag. Auf das Einschlafen ist auf LG kein Verlass - feuert visibilitychange
  // dort nicht, hat prepareForStandby nichts vorgemerkt und das Aufraeumen
  // wuerde stillschweigend ausfallen. soft_ap == 0 beweist es im Nachhinein.
  store
    .dispatch('cast/noteStandbyIfSoftApDown')
    .catch(() => false)
    .then(() => store.dispatch('cast/clearGuestCredentials'))
    .catch(() => {});
}
// LG: TV- und Radio-Player schon BEIM Einschlafen verlassen.
//
// Kam der TV aus dem Standby zurueck, stand der Gast weiter auf der zuletzt
// gewaehlten Seite. Im TV- oder Radio-Player ist das besonders schlecht:
// Tuning bzw. Stream laufen von selbst nicht wieder an, der Bildschirm blieb
// schwarz.
//
// Der Wechsel passiert deshalb BEIM EINSCHLAFEN und nicht beim Aufwachen.
// Hier laeuft die App noch vollstaendig, der Router kommt sofort durch, und
// das beforeDestroy der Player-Seite raeumt Tuner bzw. Stream ordentlich ab
// (tv/kill bzw. radio/kill) - bevor das Panel dunkel wird und waehrend im
// Standby nichts mehr tunen soll. Beim Aufwachen steht die App dann bereits
// auf Home, ohne jede Verzoegerung.
//
// lgWakeToHome() bleibt als Netz fuer den Fall, dass dieses Ereignis
// ausbleibt - etwa nach einem kalten Start statt eines Warm-Standbys.
const LG_STANDBY_LEAVE_ROUTES = ['TVPlayer', 'RadioPlayer'];
function lgLeavePlayerForStandby() {
  if (!DeviceType.isLG) return;
  const current = router.currentRoute && router.currentRoute.name;
  if (LG_STANDBY_LEAVE_ROUTES.indexOf(current) === -1) return;
  console.log('[LG] Standby - ' + current + ' verlassen, zurueck auf Home');
  router.replace({ name: 'Home' }).catch(() => {});
}
// Samsung: Fremd-App ueber der App erkennen und melden - nur beobachtend,
// siehe helpers/ForeignApp. Vor dem Listener unten registriert, damit die
// state-Meldung beim Sichtbarwerden den neuen Fall schon enthaelt.
ForeignApp.start({
  route: () => router.currentRoute && router.currentRoute.name,
  report: () => store.dispatch('socket/reportState'),
});
if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    store.dispatch('socket/reportState');
    lgCastPowerHook(document.hidden);
    if (document.hidden) lgLeavePlayerForStandby();
    else {
      // Aus dem Standby zurueck heisst: der TV hat zwischendurch selbst
      // entschieden, was er spielt - meist seinen zuletzt getunten Sender.
      // Der Merker im Router weiss davon nichts, also hier zuruecknehmen,
      // damit der Sprung auf Home wieder stoppt.
      noteTunerMayPlay();
      lgWakeToHome();
    }
  });
  // Sekundaerer Wake-Trigger fuer WebOS-Firmwares, die die App suspendieren
  // und beim Aufwecken relaunchen statt visibilitychange zu feuern.
  document.addEventListener('webOSRelaunch', () => {
    lgCastPowerHook(false);
    noteTunerMayPlay();
    lgWakeToHome();
  });
}

// Beim App-START offene Aufraeumarbeit nachholen.
//
// Notwendig fuer die echten Aus-Modi (Samsung "Virtual Standby Off", LG
// "Instant On Boot") und fuer einen Stromausfall im Standby: dort bootet der TV
// beim Einschalten neu, es gibt also weder einen Wake noch ein
// visibilitychange - der persistierte clearPending-Merker ist die einzige Spur.
//
// Ein blosser App-Reload mitten im Aufenthalt loest hier NICHTS aus: clearPending
// wird ausschliesslich beim bestaetigten Standby gesetzt. Genau darum haengt der
// Aufruf an diesem Merker und nicht an sessionActive.
function resumePendingCastClear() {
  // Zuerst: hat der letzte Neustart dem Loeschen gedient? Dann ist es durch,
  // und der Sitzungsmerker darf fallen - sonst startet der TV nach jedem
  // Standby erneut neu.
  store.dispatch('cast/settleAfterRebootClear').catch(() => {});
  // Auf LG erst den Nachweis ueber soft_ap, dann aufraeumen: nach einem echten
  // Neustart steht die Property auf 0, nach einem blossen App-Reload mitten im
  // Aufenthalt dagegen auf 1 - der Gast bleibt dann unangetastet.
  store
    .dispatch('cast/noteStandbyIfSoftApDown')
    .catch(() => false)
    .then(() => store.dispatch('cast/clearGuestCredentials'))
    .catch(() => {});
}
if (DeviceType.isLG && typeof hcap === 'undefined') {
  // Ohne hcap laeuft auf LG kein einziger Geraete-Aufruf - erst abwarten.
  window.addEventListener('hcap-ready', resumePendingCastClear, { once: true });
} else {
  resumePendingCastClear();
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store,
  methods: {
    _initHcap() {
      try {
        hcap.property.setProperty({
          "key" : "display_resolution",
          "value" : "1920x1080",
          "onSuccess" : function(s) {
              console.log("========================onSuccess-Resolution :", s);
          },
          "onFailure" : function(f) {
              console.log("========================onFailure-Resolution : errorMessage = " + f.errorMessage);
          }
        });
        hcap.property.setProperty({
          "key" : "boot_sequence_option",
          "value" : "1",
          "onSuccess" : function(s) {
              console.log("========================onSuccess-BootSequence :", s);
          },
          "onFailure" : function(f) {
              console.log("========================onFailure-BootSequence : errorMessage = " + f.errorMessage);
          }
        });
        hcap.property.setProperty({
          "key" : "tv_channel_attribute_floating_ui",
          "value" : "0",
          "onSuccess" : function(s) {
              console.log("========================onSuccess-FloatingAttribute :", s);
          },
          "onFailure" : function(f) {
              console.log("========================onFailure-FloatingAttribute : errorMessage = " + f.errorMessage);
          }
        });
        hcap.property.setProperty({
          "key" : "application_channel_control",
          "value" : "1",
          "onSuccess" : function(s) {
              console.log("========================onSuccess-application_channel_control :", s);
          },
          "onFailure" : function(f) {
              console.log("========================onFailure-application_channel_control : errorMessage = " + f.errorMessage);
          }
        });
        hcap.property.setProperty({
          "key" : "clock_display",
          "value" : "0",
          "onSuccess" : function(s) {
              console.log("========================onSuccess-clock_display :", s);
          },
          "onFailure" : function(f) {
              console.log("========================onFailure-clock_display : errorMessage = " + f.errorMessage);
          }
        });
        hcap.property.setHotelMode({
          "hotelMode" : {
               'enable': 'on',
               'settings': {
                  'powerOnStatus': 'stand_by',
                  'volume': {
                    'enable': 'on',
                    'settings': { 'startVolume': { 'enable': 'on', 'level': 10 },
                    'minimumVolume': 0, 'maximumVolume': 100 }
                  },
                  'keyManagement': {
                    'enable': 'on',
                    'settings': { 'irOperation': 'normal', 'localKeyOperation': 'normal' }
                  },
              'limitedMode': {
                'enable': 'on',
                'settings': {
                  'setupMenu': 'off',
                  'programmeChange': 'off',
                  'menuDisplay': 'off',
                  'osdDisplay': 'on',
                  'systemProviderMode': 'on'
                }
              },
              'dtvProgrammeUpdate': 'Manual',
              'powerOnDefault': {
                'enable': 'off',
                'settings': {
                  'input': 'off',
                  'programme': '2',
                  'avSetting': 'off',
                  'aspectRatio': 'disable'
                }
              },
              'auxSourceSetting': {
                'enable': 'off',
                'settings': [
                  { 'av1': 'on' },
                  { 'av2': 'on' },
                  { 'av3': 'on' },
                  { 'rgb': 'on' },
                  { 'comp1': 'on' },
                  { 'comp2': 'on' },
                  { 'comp3': 'on' },
                  { 'hdmi1': 'on' },
                  { 'hdmi2': 'on' },
                  { 'hdmi3': 'on' },
                  { 'hdmi4': 'on' }
                ]
              },
              'powerManagement': 'off',
              'radioVideoBlank': {
                'enable': 'off',
                'settings': { 'startOfRadioProgramme': 1, 'countOfRadioProgramme': 1 }
              }
            }
          },
          "onSuccess" : function(s) {
            console.log("========================onSuccess-setHotelMode :", s);
        },
        "onFailure" : function(f) {
            console.log("========================onFailure-setHotelMode : errorMessage = " + f.errorMessage);
        }
        });
      } catch(error) {
        console.log('ERROR: hcap setProperty', error);
      }
    },
  },
  /*mounted: function() {
    let connection = new WebSocket('ws://localhost:3333/');
    connection.onmessage = (event) => {
      console.log('LOG SOCKET OPEN', event);
      const message = JSON.parse(event.data);
      //messages.value.push(message);
    };
    const sendMessage = (username, text) => {
      const messageData = { username: username, message: text};
      // Send the message data to the server using WebSockets
      connection.send(JSON.stringify(messageData));
      // Add the message data to the messages array
      //messages.value.push(messageData);
    };
    setTimeout(function() {
      console.log("Callback Funktion SENDMESSAGE");
      sendMessage("NAME", "TEXT");
      }, 2000);
  }*/
  //beforeMount: function() {
    //beforeCreate: function() {
    //  var script = document.createElement('script');
    //  script.src = 'http://192.168.50.200:8080/static/hcap.js';
    //  script.setAttribute('type', 'text/javascript');
    //  document.body.appendChild(script);
    //(function(){if(!window.tizen){var s=document.createElement("script");s.src='/static/hcap.js';/*s.setAttribute('async', 'async');*/s.setAttribute('type','text/javascript');document.head.appendChild(s);}})();
    /*
    if(!window.tizen) {
      var s = document.createElement("script");
      s.src = '/static/hcap.js';
      s.setAttribute('type','text/javascript');
      document.head.appendChild(s);
    }
    */
  //},
  mounted: function() {
    //(function(){if(!window.tizen){var s=document.createElement("script");s.src='/static/hcap.js';/*s.setAttribute('async', 'async');*/s.setAttribute('type','text/javascript');document.head.appendChild(s);}})():
    if(process.env.DEBUG) {
      console.log('DEBUG MODE ON');
      //(function(){var s=document.createElement("script");s.src="https://remotejs.com/agent/agent.js";s.setAttribute("data-consolejs-channel","34d0f378-fb40-e221-2f1f-10590c88be94");document.head.appendChild(s);})();
      var script = document.createElement('script');
      script.src = process.env.DEBUG;
      //script.async;
      document.head.appendChild(script);
    } else {
      console.log('DEBUG MODE OFF');
    }
    // TV-Geräte-Performance Optimierung
    requestAnimationFrame(() => {
      if(typeof window.focus === 'function') {
        window.focus();
      }
    });
    // Samsung Tizen: App-Private-Daten (keymanager + WebStorage) so flaggen,
    // dass sie ein WGT-Update ueberleben. Ohne diesen Aufruf werden Geraete-IDs
    // beim Update der Startdatei mit gewipt.
    // Why: deferred via setTimeout + once-guard, weil der synchrone Aufruf auf
    // manchen Tizen-6.5-Modellen (z.B. BU800x Consumer) den ersten Paint
    // blockierte und zu schwarzem Bildschirm beim Cold-Boot fuehrte.
    if (DeviceType.isTizen) {
      setTimeout(() => {
        try {
          if (!window.webapis || !window.webapis.systemcontrol || typeof window.webapis.systemcontrol.deleteAppPrivateInfo !== 'function') {
            return;
          }
          if (localStorage.getItem('__tizen_persist_set__') === '1') return;
          // Samsung AppPrivateInfoState-Enum erwartet 'OFF' / 'ON' in Grossbuchstaben.
          window.webapis.systemcontrol.deleteAppPrivateInfo('OFF');
          localStorage.setItem('__tizen_persist_set__', '1');
          console.log('[Tizen] deleteAppPrivateInfo("OFF") gesetzt - App-Daten persistieren ueber WGT-Update');
        } catch (error) {
          console.log('[Tizen] deleteAppPrivateInfo("OFF") fehlgeschlagen:', error);
        }
      }, 2000);
    }
    // Samsung: Google-Cast-ToS schon beim Start akzeptieren. Samsungs
    // Hotel-SI-Checkliste (DeviceTC 8) verlangt nach Checkout und neuem
    // Check-in "ready to cast" mit akzeptierten ToS - bisher geschah das erst
    // beim Oeffnen der Cast-Seite. Verzoegert wie oben, damit der erste Paint
    // nicht wartet; die Funktion selbst wartet noch das INIT des Dienstes ab.
    // Ohne Google Cast (Tizen < 6.5) ein No-op.
    //
    // Nur, wo Cast auf diesem Geraet schon einmal vorbereitet wurde (Merker
    // aus cast/prepare): in einem Haus ohne Cast akzeptiert die App die
    // Google-ToS nicht von sich aus.
    if (DeviceType.isTizen) {
      setTimeout(() => {
        let prepared = false;
        try {
          prepared = window.localStorage.getItem(CAST_TOS_KEY) === '1';
        } catch (e) {
          prepared = false;
        }
        if (prepared) Cast.acceptCastTermsAtStart().catch(() => {});
      }, 5000);
      // Laeuft der Stand vom Server? Nach Stromlos/Neustart startet der
      // Loader oft vor dem Netz und nimmt den gemerkten alten Build - siehe
      // helpers/BuildCheck. Wartet selbst aufs Netz, haelt den Start nicht auf.
      startBuildCheck(() => store.dispatch('socket/runAppReload'));
      // Kommt die tv-app wieder nach vorn (HOME), soll ein vom Handy
      // gestarteter Cast nicht im Hintergrund weiterspielen - am BU800 lief der
      // Ton von YouTube nach HOME weiter. Siehe CastTizen.gcStopIfCasting.
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) return;
        try {
          if (Cast.stopCastOnReturn() === 'CASTING') store.dispatch('cast/noteCastSession');
        } catch (e) {
          console.log('[Cast] stopCastOnReturn fehlgeschlagen', e);
        }
      });
    }
    // LG-Fallback: sollte die Inline-Erkennung aus index.html aus irgendeinem
    // Grund (blockierende externe Scripts) noch nicht gelaufen sein, hier
    // synchron nachholen, damit _initHcap garantiert ausgeloest wird.
    if (window.isLG === undefined || window.isLG === null) {
      var ua = (navigator && navigator.userAgent) || '';
      var isLGUA = !window.tizen && (ua.indexOf("LGE") > 0 || ua.indexOf("WebOS") > 0 || ua.indexOf("webOS") > 0 || ua.indexOf("STB-") > 0);
      window.isLG = isLGUA;
      if (isLGUA && !window.lgVersion) {
        window.lgVersion = ua.indexOf("STB-5500") > 0 ? '3.5' : '5.0';
      }
    }
    // hcap-Initialisierung: sofort falls bereit, sonst auf 'hcap-ready' Event warten
    if (window.isLG) {
      const runHcap = () => {
        // Erst die echte webOS-Version aus den Geraete-Properties holen, dann
        // die Cast-Faehigkeiten ermitteln - beides braucht das Feature-Gate.
        DeviceType.refineWebOSVersion()
          .then((version) => {
            console.log('[LG] webOS-Version ermittelt:', version, window.webosInfo);
            return Cast.detect();
          })
          .then((caps) => {
            console.log('[LG] Cast-Strategie:', Cast.castStrategy(), caps);
          })
          .catch((e) => console.log('[LG] Versions-/Cast-Erkennung fehlgeschlagen', e));
        this._initHcap();
      };
      if (typeof hcap !== 'undefined' || window.hcapReady) {
        runHcap();
      } else {
        window.addEventListener('hcap-ready', runHcap, { once: true });
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js